import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const PrivacyPolicyModal = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1); // Go back to previous URL
  };

  return (
    <Modal show onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Privacy Policy</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Your privacy is important to us. We collect limited data to enhance
          your experience, and your information is secure. By using our site,
          you consent to our data practices. Contact us with any concerns.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PrivacyPolicyModal;
